import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo/logo.png'
import _imports_1 from '@/assets/images/logo/logo-text.jpg'
import _imports_2 from '@/assets/images/task.svg'


const _hoisted_1 = { class: "main-page-layout" }
const _hoisted_2 = { class: "header-logo" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { style: {"font-size":"14px"} }
const _hoisted_5 = {
  key: 0,
  class: "main-layout-side"
}
const _hoisted_6 = { class: "main-layout-navi" }

import { PoweroffOutlined, DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons-vue';
import Navi from '@/components/Navi.vue';
import {useStore} from 'vuex'
import {reactive,computed,ref, onMounted} from 'vue'
import request from '@/utils/request'
import {UserRoleMap} from '@/utils/macro.js'
import Cookies from 'js-cookie'
import TopNavDock from '@/components/TopNavDock.vue'
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPageLayout',
  setup(__props) {

const router = useRouter()
const isDev = computed(() => window.location.origin.includes('sandbox'))
const collapsed = ref<boolean>(false);
const headerStyle = {
  color: '#fff',
  height: 60,
  paddingInline: '0 16px',
  lineHeight: '60px',
  // backgroundColor: '#275BFF',
  // backgroundColor: '#737afe',
  // backgroundColor: '#69B0F3',
  // backgroundColor: '#000',

};

const contentStyle = {
  backgroundColor: '#fff',
  // backgroundColor: '#F5F7F9',
  padding: '12px 18px 0',
  flex: 'auto',
};

const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
}

const siderStyle = {
  backgroundColor: '#fff',
};
const store = useStore()
const username = computed(() => store.state.user.username)

const handleLogout = () => {
  request.get(`/api/users/logout`).then(() => {
    location.href="/"
    Cookies.remove('token_0')
  })
}
function goRouter(path) {
  router.push({path})
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "main-alayout" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, {
          style: _normalizeStyle([headerStyle, {"height":"60px","background":"#000","display":"flex","justify-content":"space-between","align-items":"center"}])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TopNavDock),
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                class: "header-logo-image",
                src: _imports_0
              }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                class: "header-logo-image-text",
                src: _imports_1
              }, null, -1))
            ]),
            _createElementVNode("div", null, [
              (isDev.value)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    style: {"padding-top":"10px","padding-bottom":"10px"}
                  }, {
                    description: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" 「 这是测试页面，正式地址请访问 ", -1),
                      _createElementVNode("a", { href: "http://marsadmin.marsvis.com" }, "marsadmin.marsvis.com", -1),
                      _createTextVNode(" 」 ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _imports_2,
                class: "task-center",
                alt: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goRouter('/keywords/taskcenter')))
              }),
              _createElementVNode("span", _hoisted_4, "当前用户: " + _toDisplayString(username.value), 1),
              _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"height":"12px","width":"1px","background":"rgb(255, 255, 255)","margin-top":"21px","margin-left":"14px","opacity":".6"} }, null, -1)),
              _createElementVNode("div", {
                class: "main-layout-logout",
                onClick: handleLogout
              }, [
                _createVNode(_unref(PoweroffOutlined)),
                _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"margin-left":"2px"} }, "退出", -1))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              style: siderStyle,
              trigger: null,
              "collapsed-width": 0,
              collapsed: collapsed.value,
              "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((collapsed).value = $event)),
              collapsible: "",
              width: "200"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "custom-collapsed-trigger",
                  style: _normalizeStyle({right:collapsed.value?'-24px':'-16px'}),
                  onClick: _cache[1] || (_cache[1] = () => (collapsed.value = !collapsed.value))
                }, [
                  (collapsed.value)
                    ? (_openBlock(), _createBlock(_unref(DoubleRightOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(DoubleLeftOutlined), { key: 1 }))
                ], 4),
                (!collapsed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(Navi)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["collapsed"]),
            _createVNode(_component_a_layout_content, { style: layoutStyle }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, { style: contentStyle }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RouterView)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})